import { Translator } from 'Translator';
import FancyCheckbox from 'components/FancyCheckbox';
import React from 'react';
import { isCordova } from 'utils/platform';

const CSS = require('./Settings.module.scss');

const settings = [
  {
    title: 'Functional',
    explanation:
      "Allows you to make use of our services and to make sure the website functions properly. You can't use the platform without these cookies.",
    editable: false,
    name: 'functional',
  },
  {
    title: 'Analytics',
    explanation:
      'Used to analyse and improve the usability and performance of the platform. These cookies are always active.',
    editable: true,
    name: 'analytics',
  },
  {
    title: 'Personalised ads',
    explanation:
      'Receive personalised advertisements based on your preferences and interests.',
    editable: true,
    name: 'personalised_ads',
  },
  {
    title: 'Advertising data sharing',
    explanation:
      'Enable data sharing to allow our partners to provide you with relevant advertisements.',
    editable: true,
    name: 'advertisement',
  },
  {
    title: 'Social',
    explanation:
      'Cookies to allow you to login and share through social platforms.',
    editable: true,
    name: 'social',
  },
];

interface SettingsProps {
  social: boolean;
  advertisement: boolean;
  personalised_ads: boolean;
  analytics: boolean;
  location: boolean;
  onSettingChange: (evt: {
    target: {
      name:
        | 'social'
        | 'advertisement'
        | 'personalised_ads'
        | 'analytics'
        | 'location';
      checked: boolean;
    };
  }) => void;
}

const Settings = ({
  onSettingChange,
  social,
  advertisement,
  analytics,
  personalised_ads,
  location,
}: SettingsProps) => {
  return (
    <ul className={CSS.Settings}>
      {settings.map(
        (setting: {
          title: string;
          explanation: string;
          name: string;
          editable: boolean;
        }) => (
          <li className={CSS.Setting} key={setting.name}>
            <div className={CSS.SettingTextContainer}>
              <span className={CSS.SettingTitle}>{setting.title}</span>
              <span className={CSS.SettingExplanation}>
                {setting.explanation}
              </span>
            </div>
            {setting.editable && (
              <FancyCheckbox
                className={CSS.SettingCheckbox}
                name={setting.name}
                checked={
                  (setting.name === 'social' && social) ||
                  (setting.name === 'advertisement' && advertisement) ||
                  (setting.name === 'personalised_ads' && personalised_ads) ||
                  (setting.name === 'analytics' && analytics)
                }
                onClick={onSettingChange}
              />
            )}
          </li>
        ),
      )}
      {isCordova() && (
        <li className={CSS.Setting} key={'location'}>
          <div className={CSS.SettingTextContainer}>
            <span className={CSS.SettingTitle}>
              {Translator.translate(
                'Consent.Cookie.locationTitle',
                {},
                true,
                'Location',
              )}
            </span>
            <span className={CSS.SettingExplanation}>
              {Translator.translate(
                'Consent.Cookie.locationExplain',
                {},
                true,
                'Share your location to get notified for cool things to do nearby.',
              )}
            </span>
          </div>
          <FancyCheckbox
            className={CSS.SettingCheckbox}
            name={'location'}
            checked={location}
            onClick={onSettingChange}
          />
        </li>
      )}
    </ul>
  );
};

export default Settings;
